import React, { useState } from 'react';

const MyComponent = () => {
  const [filePaths, setFilePaths] = useState([]);

  return (
    <div>
    </div>
  );
};

export default MyComponent;
